module.exports = __webpack_public_path__ + "img/37.a078d8bb.jpg";